import React, { useState } from 'react';
import { ExpandMore, ExpandLess } from '@mui/icons-material';
import { IconButton } from '@material-ui/core';
import moment, { Moment } from 'moment';

import { PERIODS_DEFINITION } from 'retired/PeriodSwitcher/periodsDefinition';

import { SingleBoxInterface } from '../ReportsBasicPage/reportsDefinition';

import SingleReportRow from './singleReportRow';

interface Props {
  reportType: SingleBoxInterface;
  organizationCreatedAt: Moment;
}

interface Range {
  year: number;
  quarters: number[];
}

const Quarterly: React.FC<Props> = (props: Props) => {
  const { reportType, organizationCreatedAt } = props;
  const [expanded, setExpanded] = useState<number | false>(moment().year());
  const range: Range[] = Array.from(
    Array(moment().year() - (organizationCreatedAt.year() - 1)).keys()
  ).map((item: number, index: number, arr: number[]) => {
    const result: Range = {
      year: index + organizationCreatedAt.year(),
      quarters: Array.from(Array(4).keys()),
    };
    if (index === arr.length - 1) {
      result.quarters = Array.from(Array(moment().quarters()).keys());
    }
    if (index === 0) {
      result.quarters = result.quarters.slice(organizationCreatedAt.quarters() - 1, 4);
    }
    return result;
  });

  return (
    <div
      style={{
        background: 'white',
        borderBottomLeftRadius: 20,
        borderBottomRightRadius: 20,
      }}
    >
      {range.reverse().map((item: Range, index: number, yearArr: Range[]) => (
        <div
          key={item.year}
          style={{
            fontSize: 14,
            margin: '0 30px',
          }}
        >
          <div
            role="button"
            aria-hidden="true"
            onClick={(): void => {
              setExpanded(expanded === item.year ? false : item.year);
            }}
            style={{
              height: 80,
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              borderBottom: index < yearArr.length - 1 ? `1px solid #EBEEF0` : 0,
            }}
          >
            {item.year}
            <IconButton size="small">
              {expanded === item.year ? <ExpandLess /> : <ExpandMore />}
            </IconButton>
          </div>
          <div
            style={{
              padding: `0 18px`,
              maxHeight: expanded === item.year ? 80 * item.quarters.length : 0,
              overflow: 'hidden',
              transition: `max-height .2s ease-out`,
            }}
          >
            {item.quarters.reverse().map((quarterNo: number) => {
              const quarterActual = quarterNo + 1;
              const text = `Q${quarterActual}_${item.year}_
                    ${reportType.title.split(' ').join('_')}`;
              const quarterStart = moment.utc([item.year]).quarter(quarterActual);

              return (
                <SingleReportRow
                  key={`${item.year}-${quarterNo}`}
                  shortText={`Q${quarterActual}`}
                  longText={text}
                  type={reportType.type}
                  fileName={`Quarter_${quarterActual}_${item.year}_${reportType.title
                    .split(' ')
                    .join('_')}.xlsx`}
                  from={quarterStart.valueOf()}
                  to={quarterStart.clone().add(1, 'quarter').valueOf()}
                  comparison={reportType.comparison}
                  entity={reportType.entity}
                  period={PERIODS_DEFINITION.QUARTER}
                />
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Quarterly;
